class GalleryService {
  static instance: GalleryService;

  async fetchImage(show_name: string, file_name: string) {
    const res = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}gallery/getImageData/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          show_name: show_name,
          file_name: file_name,
        }),
      }
    );
    if (!res.ok) {
      throw new Error(`Response status: ${res.status}`);
    }
    return res;
  }

  async postUserInfo({
    name,
    email,
    instagram,
  }: {
    name?: string;
    email?: string;
    instagram?: string;
  }) {
    const res = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}gallery/addGuest/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name,
          instagram: instagram,
          email: email,
        }),
      }
    );

    if (!res.ok) {
      throw new Error(`Response status: ${res.status}`);
    }
  }

  async listShowImages(show_name: string): Promise<any> {
    const res = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}gallery/${show_name}`
    );

    if (!res.ok) {
      throw new Error(`Response status: ${res.status}`);
    }

    return res;
  }

  async getState(): Promise<any> {
    const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}gallery/`);

    if (!res.ok) {
      throw new Error(`Response status: ${res.status}`);
    }

    return await res.json();
  }

  downloadImageBlob(image_blob: Blob, download_name: string) {
    const url = window.URL.createObjectURL(image_blob);
    const a = document.createElement("a");

    a.id = "imageDownload";
    a.href = url;
    a.download = `${download_name}`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async downloadImage(show_name: string, file_name: string) {
    const image = await this.fetchImage(show_name, file_name),
      blob = await image.blob();
    this.downloadImageBlob(blob, file_name);
  }
}

export default new GalleryService();
